(function ($) {

    $('.product-variations__button').on('click', function(){
        $this = $(this);
        $price = $this.siblings('.product-variations__price').html();
        $sku = $this.data('sku');

        $('.product-variations__button--selected').removeClass('product-variations__button--selected');
        $this.addClass('product-variations__button--selected');

        $('#pa_sku').val($sku).trigger('change');
        $('#product_price').html($price);
    });

    $('.product-variations__button').first().click();
})(jQuery);